function ChildrenMenu(props) {
	const menu = props.content.filter(
		(item) => item?.ID_PAR === props.currentContentId
	);
	return (
		<div style={{ flex: "0 0" }}>
			{menu.length ? (
				<div className='menu-wrapper island'>
					{menu.map((item, i) => (
						<li key={item.ID} onClick={() => props.goToArticle(item.ID)}>
							<MenuItem
								active={props.currentContentId === item.ID}
								header={item.HEADER}
								hasChild={item.HAS_CHILD}
								level={item.NUM_LEVEL}
								parentId={item.ID_PAR}
							/>
						</li>
					))}
				</div>
			) : null}
		</div>
	);
}

function MenuItem({ header, active }) {
	return <div className={`list-item ${active ? "active" : ""}`}>{header}</div>;
}

export default ChildrenMenu;
